module.exports = __webpack_public_path__ + "static/media/find-amazon-order-img.dafad1c8.png";